import { Helmet } from 'react-helmet-async';

export function PageMeta() {
	return (
		<Helmet>
			<title>Search</title>
		</Helmet>
	);
}
